import fr_BE from '../../date-picker/locale/fr_BE'
export default fr_BE



// WEBPACK FOOTER //
// ./components/calendar/locale/fr_BE.js